<template>
  <div class="reports-add-jobs">
    <el-button
      style="width: 100%"
      size="small" class="add" :type="isSelect ? 'default' : 'primary'" @click="openDialog"
    >
      {{ isSelect ? 'Сменить компанию' : '+ Выбрать компанию' }}
    </el-button>

    <el-dialog  append-to-body title="Выбрать команию" :visible.sync="dialogObject">
      <div class="add-jobs">
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div class="jobs-ul">
          <div
            @click="save(list)"
            class="jobs-li" v-for="(list, index) in filteredList" :key="index"
          >
            <span>{{ list.name }}</span>
          </div>

          <div class="jobs-li link" v-if="role === 'admin'">
            <router-link to="/dashboard/users/create/company">+ Добавить новую компанию</router-link>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {getChildList} from '@/utils/getChild';
import _ from 'lodash';
import {filterObjects} from "../../../../utils/filterJobs";
import {getPermission} from "../../../../firestore/permission";

export default {
  name: 'AddCompany',
  props: ['isSelect', 'confirmDisable', 'currentUser', 'role'],
  data() {
    return {
      search: '',
      dialogObject: false,
      unit: '',
      list: [],
    };
  },
  computed: {
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase()) &&
          (this.currentUser.company === object.name || this.role === 'admin');
      });
    },
  },

  async mounted() {
    this.fetchTree()
  },

  methods: {
    fetchTree() {
      this.loader = true;
      const result = [];
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .get()
        .then((data) => {

          data.forEach((subDoc) => {
            let _data = subDoc.data();

            result.push({..._data, id: subDoc.id});
          });
        }).finally(() => {
        this.list =  result.filter((r) => r.isCompany);
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    openDialog() {
      if (this.confirmDisable) {
        this.$emit('add-objects', null);
        return this.dialogObject = true;
      }
      if (this.isSelect) {
        this.$confirm('После смены компании вся введенная информация по работникам будет удалена, продолжить?', 'Подтверждение', {
          confirmButtonText: 'Да',
          cancelButtonText: 'Нет',
          type: 'warning',
        }).then(() => {
          this.$emit('add-objects', null);
          this.dialogObject = true;
        });
      } else {
        this.$emit('add-objects', '');
        this.dialogObject = true;
      }
    },
    save(object) {
      this.$emit('add-objects', {
        ...object,
        name: object.name,
        id: object.id,
      });
      this.close();
    },
    close() {
      this.dialogObject = false;
    },
  },
};
</script>

<style lang="scss">
.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 4px 10px !important;
    width: calc(100% - 20px);
    justify-content: flex-start;
    text-align: left;
    height: auto !important;
    min-height: 48px !important;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    span {
      text-align: left;
    }

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/company/AddCompany.vue